import { gql } from '@apollo/client/core'
// import { RESOURCE_TAG_FRAGMENT } from '../fragments/ResourceTag'

export const LIST_RESOURCE_TAGS_QUERY = gql`
  query listResourceTags {
    listResourceTags(filter: {}) {
      ... on ListResourceTagsOutput {
        resourceTags {
          id
          label
          slug
          position
        }
      }
    }
  }
`
